import type { QBSLevelItemExcludingTag } from '../types';

export function updateQBankStructureLevelItemsOrder(
  qBankStructureLevelItems: QBSLevelItemExcludingTag[],
) {
  // Initialize the order counter
  let currentOrder = 1;

  return qBankStructureLevelItems.map((qBankStructureLevelItem) => {
    // Check if the item is non-informational node (order is 0)
    const isNonInfo = qBankStructureLevelItem.order === 0;

    // If the item is non-informational node return it as is
    // Otherwise, update its order and increment the order counter
    return isNonInfo
      ? qBankStructureLevelItem
      : { ...qBankStructureLevelItem, order: currentOrder++ };
  });
}

export function findLastOrderBySiblings(
  levelItems: QBSLevelItemExcludingTag[],
  parentLevelItemId: string | null,
) {
  const siblings = levelItems.filter((item) => item.parentLevelItemId === parentLevelItemId);

  return siblings.reduce((maxOrder, item) => {
    return item.order > maxOrder ? item.order : maxOrder;
  }, 0);
}

export function updateOrderOfLevelItemOnNameChange(
  levelItems: QBSLevelItemExcludingTag[],
  id: string,
  name: string | null,
  previousName: string | null,
) {
  if (!previousName && !!name) {
    const levelItem = levelItems.find((item) => item.id === id);
    if (levelItem?.order === 0) {
      const lastOrder = findLastOrderBySiblings(levelItems, levelItem.parentLevelItemId);

      return levelItems.map((item) => (item.id === id ? { ...item, order: lastOrder + 1 } : item));
    }
  }
  return levelItems;
}
